import styles from './ClassNameEditor.module.css';
import React, { useState, useEffect, useRef } from 'react';

/** Inline editor that appears when you click the class name */
const ClassNameEditor: React.FC<{
  name: string;
  onSave: (newName: string) => void;
}> = ({ name, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(name);
  const inputRef = useRef<HTMLInputElement>(null);

  // focus + select when we switch to edit mode
  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [editing]);

  const finish = () => {
    setEditing(false);
    if (value.trim() !== name) onSave(value.trim());
  };

  if (!editing)
    return (
      <span
        className={styles.classNameDisplay}
        onClick={() => setEditing(true)}
        title="Click to edit"
      >
        {name}
      </span>
    );

  return (
    <input
      ref={inputRef}
      type="text"
      value={value}
      onChange={e => setValue(e.target.value)}
      onBlur={finish}
      onKeyDown={e => e.key === 'Enter' ? finish() : e.key === 'Escape' && setEditing(false)}
      className={styles.classNameInput}
    />
  );
};


export { ClassNameEditor }
